import {Assignment} from '@features/assignment/types.ts'
import {create} from 'zustand'
import {CHATBOT_SOURCES, ChatbotCancellationReason, HistoryStep} from '@features/chatbot/types.ts'
import {RefObject} from 'react'

interface ChatbotStore {
    assignment: Assignment | null
    selectedAssignment: Assignment | null
    cancellationReason: ChatbotCancellationReason
    chatbotRef: RefObject<unknown> | null
    sessionId: string | null
    setAssignment: (assignment: Assignment | null) => void
    setSelectedAssignment: (assignment: Assignment | null) => void
    setCancellationReason: (cancelReason: ChatbotCancellationReason) => void
    setChatbotRef: (chatbotRef: RefObject<unknown>) => void
    setSessionId: (sessionId: string) => void
    addStepToHistory: ({
        id,
        source,
        text
    }: {
        id: string
        source: typeof CHATBOT_SOURCES.CHATBOT | typeof CHATBOT_SOURCES.USER
        text: string
    }) => void
    resetChatHistory: () => void
    resetSelectedAssignment: () => void
    chatHistory: HistoryStep[]
}

export const useChatbotStore = create<ChatbotStore>(set => ({
    chatbotRef: null,
    assignment: null,
    selectedAssignment: null,
    cancellationReason: {id: null, text: null},
    chatHistory: [],
    sessionId: '',
    addStepToHistory: ({id, source, text}) =>
        set(state => {
            return {chatHistory: [...state.chatHistory, {id, message: `${source}: ${text}`}]}
        }),
    setCancellationReason: cancelReason => set({cancellationReason: cancelReason}),
    setAssignment: assignment => set({assignment}),
    setSelectedAssignment: assignment => set({selectedAssignment: assignment}),
    setChatbotRef: ref => set({chatbotRef: ref}),
    setSessionId: sessionId => set({sessionId}),
    resetChatHistory: () => set({chatHistory: []}),
    resetSelectedAssignment: () => set({selectedAssignment: null})
}))
